import cn from 'classnames'
import { CSSProperties, FC } from 'react'

import { CircleCheckIcon, CircleIcon } from 'project/icons'

type CheckboxProps = {
  checked: boolean
  className?: string
  disabled?: boolean
  id: string
  label?: string
  onChange?: (newValue: boolean) => void
}

const Checkbox: FC<CheckboxProps> = ({
  checked,
  className,
  disabled,
  id,
  label,
  onChange,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange?.(!checked)
    }
  }

  const cursorStyle: CSSProperties = {
    cursor: disabled ? 'not-allowed' : 'pointer',
  }

  const IconComponent = checked ? CircleCheckIcon : CircleIcon

  return (
    <div
      className={cn(
        'lh-input d-flex align-items-center gap-1 user-select-none',
        className,
      )}
    >
      <IconComponent onClick={handleClick} style={cursorStyle} />
      {label && (
        <label
          className='form-check-label'
          htmlFor={id}
          onClick={handleClick}
          style={cursorStyle}
        >
          {label}
        </label>
      )}
    </div>
  )
}

Checkbox.displayName = 'Checkbox'
export default Checkbox
